import {setCurrentSection, setSectionSelected} from '../../utilities';
import {NOTEBOOK_SECTIONS} from '@learningblocks/protocol-constants/lib/Utilities';

// functions updates stateTree for NotebookSection change
export function setNewNotebookSection(state, payload) {

  const levelData = updateLevelData(state);
  if(state.currentSection){
    levelData.GENERIC_CHAPTERS[state.currentSection.title] = state.currentSection
  }

  return {
    ...state,
    levelData,
    sections: setSectionSelected(state.sections, payload.section),
    currentSection: setCurrentSection(levelData, payload.section)
  };
}

// functions updates key levelData with any changes from current session
// before updating current session.
function updateLevelData(state) {
  const currentSection = getCurrentSection(state.sections);

  const {levelData} = state;
  return {...levelData, [currentSection]: state.currentSection};

  // if (currentSection === NOTEBOOK_SECTIONS.PROTOCOL) {
  //   return state.levelData;
  // } else {
  //   const {levelData} = state;
  //   return {...levelData, [currentSection]: state.currentSection};
  // }
}

// get name of currentSession
function getCurrentSection(sections) {
  const {value} = sections.find((section) => section.current === true);
  return value;
}
